import { Badge } from "@/components/ui/badge";

export function EventAttendingBadge() {
  return (
    <Badge variant="outline">
      <div className="flex items-center gap-2">
        <div className="h-1.5 w-1.5 rounded-lg bg-green-500" />
        <span className="text-muted-foreground">Attending</span>
      </div>
    </Badge>
  );
}
